import React from 'react';
import { PageTitle } from '../PageTitle';

export const Search = () => (
    <>
        <PageTitle title="Search" />
        <div>[TODO]</div>
    </>
);
